import { ActionReducerMapBuilder, PayloadAction } from "@reduxjs/toolkit";
import { AnnouncementResponse } from "api/announcement/type";
import { ResponseCode } from "contants/response";
import { NoInfer } from "react-redux";
import { AnnouncementType } from "types/announcement";

import { getAnnouncement, getHomeAnnouncement } from "./announcement.thunk";

export const extraReducers = (
  builder: ActionReducerMapBuilder<NoInfer<AnnouncementType>>
) => {
  builder
    .addCase(getAnnouncement.pending, (state: AnnouncementType) => {
      state.isLoading = true;
    })
    .addCase(
      getAnnouncement.fulfilled,
      (
        state: AnnouncementType,
        action: PayloadAction<AnnouncementResponse>
      ) => {
        state.isLoading = false;

        if (action.payload.status !== ResponseCode.SUCCESS) return;

        const dataRes = action.payload.data;
        const currentPage = action.payload.currentPage;
        state.currentPage = currentPage;

        if (action.payload.type === 1) {
          state.dataByType =
            currentPage > 1 ? [...state.dataByType, ...dataRes] : dataRes;
          return;
        }
        state.data = currentPage > 1 ? [...state.data, ...dataRes] : dataRes;
        state.totalCount = action.payload.totalCount;
        state.totalPages = action.payload.totalPages;
        state.pageSize = action.payload.pageSize;
      }
    )
    .addCase(getAnnouncement.rejected, (state: AnnouncementType) => {
      state.isLoading = false;
    })
    .addCase(getHomeAnnouncement.pending, (state: AnnouncementType) => {
      state.isHomeLoading = true;
    })
    .addCase(
      getHomeAnnouncement.fulfilled,
      (
        state: AnnouncementType,
        action: PayloadAction<AnnouncementResponse>
      ) => {
        state.isHomeLoading = false;

        if (action.payload.status !== ResponseCode.SUCCESS) return;

        state.homeData = action.payload.data;
        state.hasFetchedHomeData = true;
      }
    )
    .addCase(getHomeAnnouncement.rejected, (state: AnnouncementType) => {
      state.isHomeLoading = false;
    });
};
